import { render, staticRenderFns } from "./examRecommendManage.vue?vue&type=template&id=597e6f8a&scoped=true"
import script from "./examRecommendManage.vue?vue&type=script&lang=js"
export * from "./examRecommendManage.vue?vue&type=script&lang=js"
import style0 from "./examRecommendManage.vue?vue&type=style&index=0&id=597e6f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597e6f8a",
  null
  
)

export default component.exports